export const noop = (): void => {
  //
};
export const noopPromise = (): Promise<void> => Promise.resolve();
export type Optional<T> = T | undefined;
export type Nullable<T> = T | null;
